import { useCallback, useEffect, useId, useRef } from 'react';
import { getKidSub, useAuthStore } from '@/auth/authStore';

/** A late recovery response belongs to its original actor, source and render generation. */
export function useStudyRecoveryScope(source: string) {
  const instance = useId();
  const owner = useAuthStore(() => getKidSub());
  const identity = JSON.stringify([owner, source]);
  const generation = useRef({ identity, value: 0 });
  if (generation.current.identity !== identity)
    generation.current = { identity, value: generation.current.value + 1 };
  const scope = JSON.stringify([instance, identity, generation.current.value]);
  const current = useRef({ scope, owner });
  current.current = { scope, owner };
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const isCurrent = useCallback(
    (requestScope: string) =>
      mounted.current &&
      current.current.scope === requestScope &&
      Boolean(current.current.owner) &&
      getKidSub() === current.current.owner,
    [],
  );
  return { owner, scope, isCurrent };
}
